<div class="posterCard">
    <a class="posterImage" [routerLink]="['/movies/', movie?.Dx ]" routerLinkActive="router-link-active" >
        <img [src]="movie?.Poster" alt="">
        <div *ngIf="movie?.isDefault" class="title">
            {{movie?.Title }}
        </div>
    </a>
    <app-add *ngIf="movie" [movie]="movie"></app-add>
    <div class="buttons">
        <div class="bookNow" (click)="onBookNow()">
            Book Now
        </div>
        <a  [routerLink]="['/movies/', movie?.Dx ]">
            <div class="info">
                More Info
            </div>
        </a>   
    </div>
</div>